import { Activity } from 'react'
import NotificationIcon from '../../../assets/icons/notificationIcon.svg?react'
import { useLocalization, LocalizationKeys } from '../../../i18n'
import { useNotifications } from '../../../hooks/context/useNotifications'
import styles from './notificationBtn.module.css'
import { NotificationContainer } from './notificationContainer/notificationContainer'
import { useCloseOnInteractions } from '../../../hooks/useCloseOnInteractions'
import { useToggle } from '../../../hooks/useToggle'

export function NotificationBtn() {
  const { isOpen, toggle, close } = useToggle(false)
  const { t } = useLocalization()
  const { notifications } = useNotifications()
  const wrapperRef = useCloseOnInteractions<HTMLDivElement>({
    isActive: isOpen,
    onClose: close,
  })

  const unreadCount = notifications.filter(n => !n.isWatched).length

  return (
    <div className={styles.notificationWrapper} ref={wrapperRef}>
      <button
        type="button"
        className={`${styles.notificationBtn} ${isOpen ? styles.active : ''}`}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label={t(LocalizationKeys.HEADER_NOTIFICATIONS)}
        onClick={toggle}
      >
        <NotificationIcon className={styles.icon} />
        <Activity mode={unreadCount > 0 ? 'visible' : 'hidden'}>
          <span className={styles.badge}>
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        </Activity>
      </button>

      {isOpen && <NotificationContainer />}
    </div>
  )
}
